'use strict';

var d3 = require('d3');
var _ = require('lodash');

/**
 * Draggable Bars
 *
 * Renders draggable bars
 *
 * @returns {Function}
 * @constructor
 */
var DraggableBars = function DraggableBars(d3Helper) {
  /**
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (yPropertyName) {
    var dispatch = d3.dispatch('bardragged');
    var params, scales;
    var itemsCount = 1;
    var maxItemsCount = 1;
    var isDraggable = true;
    function yFunction(d) {
      var tempY = scales.yScale(Math.max(d[yPropertyName], 0));
      var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyName]));
      if (d[yPropertyName] !== 0 && tempHeight === 0) {
        tempY = tempY - 1;
      }
      return tempY;
    }
    function xFunction(d, i) {
      var groupWidth = scales.xScale.rangeBand();
      var singleBarWidth = groupWidth / getMaxGroupItemsCount();
      var leftPadding = (groupWidth - itemsCount * singleBarWidth) / 2;
      return leftPadding + singleBarWidth * i;
    }
    function xReverseFunction(d, i) {
      return xFunction(d, itemsCount - (i + 1));
    }
    function heightFunction(d) {
      var tempHeight = Math.abs(scales.yScale(0) - scales.yScale(d[yPropertyName]));
      if (d[yPropertyName] !== 0 && tempHeight === 0) {
        tempHeight = tempHeight + 1;
      }
      return tempHeight;
    }
    function widthFunction() {
      var groupWidth = scales.xScale.rangeBand();
      return groupWidth / getMaxGroupItemsCount() - 3;
    }
    function fillFunction(d) {
      if (!Array.isArray(d.fill)) {
        return d.fill;
      }
    }
    function classFunction(d) {
      return yPropertyName + '-bar' + ' simple-bar' + (d[yPropertyName] < 0 ? ' negative-value' : '');
    }
    function getMaxGroupItemsCount() {
      return _.max([maxItemsCount, itemsCount]);
    }
    function itemsAreDefined(d) {
      return _.every(d.items, function (barItem) {
        return barItem[yPropertyName] !== undefined;
      });
    }
    function removeDragHandlers(selection) {
      selection.on('.drag', null);
    }

    /**
     *
     * @param container
     */
    var bars = function bars(container) {
      var selector = yPropertyName + '-bar';
      var group = container.select('.groups').selectAll('.stack.visible');
      group.each(function (d) {
        if (itemsAreDefined(d)) {
          itemsCount = d.items.length;
          var bars = d3Helper.createGroupElement(d3.select(this), 'bars');
          var simpleBars = bars.selectAll('.' + selector + '.simple-bar').data(d.items);
          simpleBars.enter().append('rect');
          simpleBars.attr({
            'class': classFunction,
            'y': yFunction,
            'x': xFunction,
            'width': widthFunction,
            'height': heightFunction
          }).style({
            'fill': fillFunction
          });
          simpleBars.exit().remove();
          var simpleBarHandles = d3.select(this).selectAll('.' + selector + '.simple-bar-handle').data(isDraggable ? _.takeRight(d.items) : []);
          simpleBarHandles.enter().append('rect').attr({
            'class': selector + ' simple-bar-handle',
            'height': 6
          }).style({
            cursor: 'pointer',
            opacity: 0.0
          }).call(d3.behavior.drag().origin(function (d) {
            return {
              x: xReverseFunction,
              y: yFunction(d)
            };
          }).on('dragstart', dragstarted).on('drag', dragged).on('dragend', dragended));
          simpleBarHandles.attr({
            width: widthFunction,
            y: function y(d) {
              return yFunction(d) - 3;
            },
            x: xReverseFunction
          });
          simpleBarHandles.exit().call(removeDragHandlers).remove();
        }
      });
    };
    function dragstarted() {
      d3.select(this.parentNode.parentNode) // jshint ignore:line
      .classed('dragging-in-process', true);
      d3.select(this.parentNode) // jshint ignore:line
      .classed('dragged-bar', true);
    }
    function dragged(d) {
      var domain = scales.yScale.domain();
      var domainValue = Math.round(100 * scales.yScale.invert(d3.event.y)) / 100;
      if (domain[0] <= domainValue && domainValue <= domain[1]) {
        d[yPropertyName] = domainValue;
        dispatch.bardragged(d);
      }
    }
    function dragended() {
      d3.select(this.parentNode.parentNode) // jshint ignore:line
      .classed('dragging-in-process', false);
      d3.select(this.parentNode) // jshint ignore:line
      .classed('dragged-bar', false);
    }

    /**
     *  Setters and getters
     */

    bars.params = function (value) {
      params = value;
      return bars;
    };
    bars.scales = function (value) {
      scales = value;
      return bars;
    };
    bars.maxItemsCount = function (value) {
      maxItemsCount = value;
      return bars;
    };
    bars.draggable = function (value) {
      isDraggable = value;
      return bars;
    };
    return d3.rebind(bars, dispatch, 'on');
  };
};
DraggableBars.$inject = ['d3Helper'];
module.exports = DraggableBars;